import { cn } from "@/utils/twMerge";

export default function Divider({ className = "" }) {
  return (
    <div>
      <div className={cn("w-full h-[1px] bg-greyscaleGON-100", className)} />
    </div>
  );
}
